export default __webpack_public_path__ + "static/media/bg-pattern-header.d3afcf03.svg";